import { cn } from "@/lib/utils";
import Logo from "./logo";
import { Row } from "@/app/v2/_components/row/Row";
import Link from "next/link";

export default function BetterEmailLogo({
  wrapperClassName,
  textClassName,
  size = "default",
  logoOnly = false,
  linkHome,
}: {
  wrapperClassName?: string;
  iconClassName?: string;
  size?: "default" | "lg";
  textClassName?: string;
  linkHome?: boolean;
  logoOnly?: boolean;
}) {
  return (
    <Row align shrink tightGap className={wrapperClassName}>
      <Logo className={cn("w-6 h-6", size === "lg" && "w-8 h-8")} />
      {!logoOnly && (
        <>
          {linkHome ? (
            <Link href="/v2">
              <span
                className={cn(
                  "text-xxl font-bold hidden sm:inline-block tracking-tight hover:text-primary transition-colors duration-100 cursor-pointer",
                  size === "lg" && "text-[1.5rem]",
                  textClassName,
                )}
              >
                Better Email
              </span>
            </Link>
          ) : (
            <span className={cn("text-xxl font-bold hidden sm:inline-block tracking-tight", size === "lg" && "text-[1.5rem]", textClassName)}>
              Better Email
            </span>
          )}
        </>
      )}
    </Row>
  );
}
